export default __webpack_public_path__ + "static/media/join_group_icon.fa1ddfb6.svg";